(ns rothko.theme.wandi.core
  (:require [rothko.theme.wandi.button :as button]))

(def main
  {:styles
   {:button button/main}})
